import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

// Existing components, forms, pipes, etc.
import { AddressEditorComponent } from './components/address-editor/address-editor.component';
import { PostalCodeFormComponent } from './forms/postal-code-form/postal-code-form.component';
import { AddressFormComponent } from './forms/address-form/address-form.component';
import { AddressEditorModalComponent } from './components/address-editor-modal/address-editor-modal.component';
import { QrCodeComponent } from './components/qr-code/qr-code.component';
import { BarcodeComponent } from './components/barcode/barcode.component';
import { PhonePipe } from './pipes/phone.pipe';
import { ChunkSplitPipe } from './pipes/chunk.split.pipe';
import { NumberSlicePipe } from './pipes/number.slice.pipe';
import { FormatAddressPipe } from './pipes/address.form.pipe';
import { CreditCardFormComponent } from './forms/credit-card-form/credit-card-form.component';
import { AddressComponent } from './components/address/address.component';
import { CreditCardListComponent } from '../account/components/credit-card-list/credit-card-list.component';
import { CreditCardCheckoutComponent } from '../account/components/credit-card-checkout/credit-card-checkout.component';
import { AddCreditCardModalComponent } from '../account/modals/add-credit-card-modal/add-credit-card-modal.component';
import { NumPadComponent } from './modals/num-pad/num-pad.component';
import { LogoDirective } from './directives/logo.directive';
import { ModalDisplayComponent } from './components/modal-display/modal-display.component';
import { MenuItemDetailModalComponent } from './modals/menu-item-detail-modal/menu-item-detail-modal.component';
import { MenuItemOptionDetailModalComponent } from './modals/menu-item-option-detail-modal/menu-item-option-detail-modal.component';
import { LoginFormComponent } from '../auth/forms/login-form/login-form.component';
import { ForgotPasswordFormComponent } from '../auth/forms/forgot-password-form/forgot-password-form.component';
import { RegisterFormComponent } from '../auth/forms/register-form/register-form.component';
import { AutocompleteOffDirective } from './directives/autocompleteOff.directive';
import { AddressPostalCodeComponent } from './components/address-postalcode/address-postalcode.component';
import { AppMenuNavComponent } from '../store/components/app-menu-nav/app-menu-nav.component';
import { MenuComponent } from '../store/components/menu/menu.component';
import { CreditCardFormComponentDesktop } from './forms/credit-card-form-desktop/credit-card-form-desktop.component';
import { AddressEditorDesktopModalComponent } from './components/address-editor-desktop-modal/address-editor-desktop-modal.component';
import { AddressDesktopComponent } from './components/address-desktop/address-desktop.component';
import { NotificationbellComponent } from './components/notificationbell/notificationbell.component';
import { UndockedNavigationBarComponent } from './components/undocked-navigation-bar/undocked-navigation-bar.component';
//import { SwiperModule } from 'swiper/angular';



// Angular Material + Carousel
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
//import { IvyCarouselModule } from 'angular-responsive-carousel';

// ✅ Cookie Consent Modal - newly added
import { CookieConsentModalComponent } from './modals/cookie-consent-modal/cookie-consent-modal.component';
import { CookieConsentPopupComponent } from './modals/cookie-consent-modal/cookie-consent-popup.component';
import { ViewPromoOfferComponent } from './components/view-promo-offer/view-promo-offer.component';
import { AlertsComponent } from './modals/alerts/alerts.component';



// updated libraries:
//--

// custom pipes:
import { TranslatePipe } from '../pipes/translate.pipe';
import { FaiconComponent } from './components/faicon/faicon.component';
import { BlogsComponent } from './components/blogs/blogs.component';
import { NewsComponent } from './components/news/news.component';
import { MenuItemAllinoneModalComponent } from './modals/menu-item-allinone-modal/menu-item-allinone-modal.component';
import { ItemContentDetailsModalComponent } from './modals/item-content-details-modal/item-content-details-modal.component';
import { GamesComponent } from './components/games/games.component';
import { LanguageRequestModalsComponent } from './modals/language-request-modals/language-request-modals.component';
import { LoginLandingPageComponent } from './components/login-landing-page/login-landing-page.component';


@NgModule({
  declarations: [
    //GameComponent,
    TranslatePipe, 
    AddressEditorComponent,
    AddressEditorDesktopModalComponent,
    PostalCodeFormComponent,
    AddressFormComponent,
    AddressEditorModalComponent,
    QrCodeComponent,
    BarcodeComponent,
    PhonePipe,
    ChunkSplitPipe,
    NumberSlicePipe,
    FormatAddressPipe,
    CreditCardFormComponent,
    CreditCardFormComponentDesktop,
    AddressComponent,
    AddressDesktopComponent,
    CreditCardListComponent,
    CreditCardCheckoutComponent,
    AddCreditCardModalComponent,
    NumPadComponent,
    LogoDirective,
    ModalDisplayComponent,
    MenuItemDetailModalComponent,
    MenuItemOptionDetailModalComponent,
    AutocompleteOffDirective,
    AddressPostalCodeComponent,
    AppMenuNavComponent,
    MenuComponent,
    NotificationbellComponent,
    UndockedNavigationBarComponent,
    CookieConsentModalComponent,
    CookieConsentPopupComponent,
    ViewPromoOfferComponent,
    AlertsComponent,
    //FaiconComponent,
    BlogsComponent,
    NewsComponent,
    MenuItemAllinoneModalComponent,
    ItemContentDetailsModalComponent,
    GamesComponent,
    LanguageRequestModalsComponent,
    LoginLandingPageComponent
    
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    //TranslateModule.forChild(),

    
    // Angular Material
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatCheckboxModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDialogModule,
    MatDatepickerModule,
    MatDividerModule,
    MatExpansionModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatGridListModule,
    MatNativeDateModule,
    MatListModule,
    FaiconComponent,


    //SwiperModule

    //IvyCarouselModule,

  ],
  exports: [
    //GameComponent,
    TranslatePipe,
    PostalCodeFormComponent,
    AddressEditorComponent,
    AddressEditorDesktopModalComponent,
    QrCodeComponent,
    BarcodeComponent,
    PhonePipe,
    ChunkSplitPipe,
    NumberSlicePipe,
    FormatAddressPipe,
    CreditCardFormComponent,
    CreditCardFormComponentDesktop,
    AddressComponent,
    AddressDesktopComponent,
    CreditCardListComponent,
    CreditCardCheckoutComponent,
    AddCreditCardModalComponent,
    NumPadComponent,
    LogoDirective,
    AutocompleteOffDirective,
    ModalDisplayComponent,
    MenuItemDetailModalComponent,
    MenuItemOptionDetailModalComponent,
    AddressPostalCodeComponent,
    AppMenuNavComponent,
    MenuComponent,
    NotificationbellComponent,
    UndockedNavigationBarComponent,
    CookieConsentModalComponent,
    CookieConsentPopupComponent,
    FaiconComponent,
    BlogsComponent,
    NewsComponent,
    MenuItemAllinoneModalComponent,
    ItemContentDetailsModalComponent,
    GamesComponent,
    LanguageRequestModalsComponent,
    LoginLandingPageComponent
  ],
  providers: [
    PhonePipe,
    ChunkSplitPipe,
    NumberSlicePipe,
    FormatAddressPipe
  ],
  // Let Angular recognize Ionic components
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
